export default "__VITE_ASSET__DglRIWpo__"